<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';

const { calculatedMenuMode } = useLayout();
const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});
const sidebarGroupLabelVariants = cva('shrink-0 text-xs font-medium text-surface-500 uppercase whitespace-nowrap truncate transition-[margin,opacity,transform] duration-100 ease-linear [&>svg]:size-4 [&>svg]:shrink-0', {
    variants: {
        variant: {
            compact: 'opacity-0 pointer-events-none data-[state=collapsed]:-translate-y-1',
            slim: 'opacity-0 pointer-events-none data-[state=collapsed]:-translate-y-1',
            drawer: 'group-data-[state=collapsed]/sidebar-wrapper:-translate-y-2 group-data-[state=collapsed]/sidebar-wrapper:opacity-0 group-data-[state=collapsed]/sidebar-wrapper:pointer-events-none',
            reveal: 'group-data-[state=collapsed]/sidebar-wrapper:-translate-y-2 group-data-[state=collapsed]/sidebar-wrapper:opacity-0 group-data-[state=collapsed]/sidebar-wrapper:pointer-events-none'
        }
    }
});
const sidebarGroupLabelClass = computed(() => {
    return sidebarGroupLabelVariants({ variant: calculatedMenuMode.value, class: props.class });
});
</script>

<template>
    <div :class="sidebarGroupLabelClass">
        <slot />
    </div>
</template>
